export default "__VITE_ASSET__DH1945zA__"